import React, { useEffect, useState } from "react";
import i18n from "i18next";

// Fabric Imports
import { fetchWrapper } from "../../../helpers/fetchwrapper";

import { baseUrl } from "../../../helpers/constants";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Button,
  Input,
  Field,
  Divider,
} from "@fluentui/react-components";
import { IUserBedarfPosition } from "../../../Models/IUserBedarfPosition";
import { AddFilled, SubtractFilled } from "@fluentui/react-icons";

interface IDialogEditUserBedarfProps {
  isDialogOpen: boolean;
  onDismiss(): void;
  userBedarf: IUserBedarfPosition | undefined;
}

function DialogEditUserBedarf(props: IDialogEditUserBedarfProps) {
  const [editBedarf, setEditBedarf] = useState<IUserBedarfPosition | undefined>(
    props.userBedarf
  );
  const handleEditBedarfValuesChange = (name: string, val: any) => {
    setEditBedarf((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  useEffect(() => {
    setEditBedarf(props.userBedarf);
  }, [props.userBedarf]);

  /*  const editUserBedarfDialogProps = {
    type: DialogType.largeHeader,
    title: i18n.t<string>("editUserBedarf"),
    subText: "",
  }; */

  const saveUserBedarf = () => {
    var tempEditBedarf: any = editBedarf;
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/userbedarfe/edit`, tempEditBedarf)
      .then((result: any) => {
        props.onDismiss();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  {
    if (editBedarf)
      return (
        <Dialog open={props.isDialogOpen}>
          <DialogSurface>
            <DialogBody>
              <DialogTitle>{i18n.t<string>("editUserBedarf")}</DialogTitle>
              <DialogContent>
                <Field label={i18n.t<string>("artikelId")}>
                  <Input
                    appearance="filled-darker"
                    style={{ width: "100%" }}
                    defaultValue={
                      editBedarf?.artikel
                        ? editBedarf?.artikel?.artikelId
                        : editBedarf?.produkt?.produktId
                    }
                    readOnly
                  />
                </Field>
                <Field label={i18n.t<string>("benennung")}>
                  <Input
                    onFocus={() => {}}
                    appearance="filled-darker"
                    style={{ width: "100%" }}
                    defaultValue={
                      i18n.language.includes("de")
                        ? editBedarf?.benennungDE
                        : editBedarf?.benennungEN
                    }
                    readOnly
                  />
                </Field>
                <Divider
                  appearance="brand"
                  style={{ marginTop: "10px", marginBottom: "5px" }}
                ></Divider>
                <Field label={i18n.t<string>("kundenReferenz")}>
                  <Input
                    style={{ width: "100%" }}
                    defaultValue={editBedarf?.kundenReferenz}
                    onChange={(ev, data) =>
                      handleEditBedarfValuesChange("kundenReferenz", data.value)
                    }
                  />
                </Field>
                <Field label={i18n.t<string>("menge")}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      appearance="primary"
                      shape="circular"
                      size="small"
                      icon={<SubtractFilled />}
                      onClick={() => {
                        if (editBedarf.menge && editBedarf.menge >= 1) {
                          handleEditBedarfValuesChange(
                            "menge",
                            editBedarf.menge - 1
                          );
                        }
                      }}
                    />
                    <Input
                      style={{
                        width: "50px",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      value={editBedarf.menge?.toString()}
                      onChange={(ev, data) =>
                        handleEditBedarfValuesChange(
                          "menge",
                          Number(data.value)
                        )
                      }
                    />
                    <Button
                      appearance="primary"
                      shape="circular"
                      size="small"
                      icon={<AddFilled />}
                      onClick={() => {
                        if (editBedarf.menge) {
                          handleEditBedarfValuesChange(
                            "menge",
                            editBedarf.menge + 1
                          );
                        }
                      }}
                    />
                  </div>
                </Field>
              </DialogContent>
              <DialogActions>
                <Button
                  appearance="primary"
                  onClick={() => {
                    saveUserBedarf();
                  }}
                >
                  {i18n.t<string>("save")}
                </Button>
                <Button onClick={() => props.onDismiss()}>
                  {i18n.t<string>("cancel")}
                </Button>
              </DialogActions>
            </DialogBody>
          </DialogSurface>
        </Dialog>
      );
    else {
      return <div></div>;
    }
  }
}

export default DialogEditUserBedarf;
